<template>
  <div class="wsfz">
    <li>
      <div class="label">户主姓名</div>
      <div class="value">
        {{yhDetail.name}}
        <img style="visibility: hidden" src="../../../../static/image/jt.png" alt="">
      </div>
    </li>
    <li>
      <div class="label">用户编码</div>
      <div class="value">
        {{yhDetail.code}}
        <img style="visibility: hidden" src="../../../../static/image/jt.png" alt="">
      </div>
    </li>
    <li v-if="yhDetail.yhkh">
      <div class="label">用户卡号</div>
      <div class="value">
        {{yhDetail.yhkh}}
        <img style="visibility: hidden" src="../../../../static/image/jt.png" alt="">
      </div>
    </li>
    <li @click="toPage('身份证号', yhDetail.idNumber)">
      <div class="label">身份证号</div>
      <div class="value">
        {{yhDetail.idNumber}}
        <img  :style="yhDetail.idNumber?'visibility: hidden':''" src="../../../../static/image/jt.png" alt="">
      </div>
    </li>
    <li>
      <div class="label">所属小区</div>
      <div class="value">{{yhDetail.three}}
        <img style="visibility: hidden" src="../../../../static/image/jt.png" alt="">
      </div>
    </li>
    <li>
      <div class="label">地址</div>
      <div class="value">{{yhDetail.address}}
        <img style="visibility: hidden" src="../../../../static/image/jt.png" alt="">
      </div>
    </li>
    <li @click="toPage('手机号', yhDetail.mobNo)">
      <div class="label">手机号</div>
      <div class="value">{{yhDetail.mobNo}}
        <img src="../../../../static/image/jt.png" alt="">
      </div>
    </li>
    <li @click="toPage('邮箱', ylDetail.email)">
      <div class="label">邮箱</div>
      <div class="value">{{ylDetail.email}}
        <img src="../../../../static/image/jt.png" alt="">
      </div>
    </li>
    <li @click="toPage('密码', ylDetail.pwd)">
      <div class="label">密码修改</div>
      <div class="value">
        <img src="../../../../static/image/jt.png" alt="">
      </div>
    </li>
  </div>
</template>

<script>
  import {findWechatBind, getUser} from "@/api";

  export default {
    data() {
      return {
        yhDetail: {},
        ylDetail: {}
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      getData() {
        getUser({
          code: this.$route.query.code
        }).then(res=>{
          this.yhDetail = res.data
        })
        findWechatBind({
          customerId: this.$route.query.userId
        }).then(res=>{
          this.ylDetail = res.data
        })
      },
      toPage(key, value) {
        if(key=='身份证号'&&value) {
          return
        }
        this.$router.push({
          path: '/yhxxxg',
          query: {
            key,
            value,
            ...this.$route.query
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .wsfz{
    /*background: #fff;*/
    height: 93%;
    width: 100%;
    padding-top: 2%;
    li{
      background: #fff;
      display: flex;
      justify-content: space-between;
      line-height:50px;
      padding: 0 3%;
      align-items: center;
      border-bottom: 1px solid #F5F5F5;
      .label{
        color: #202020;
        font-weight: 600;
      }
      .value{
        color: #646464;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ywbl/wsfz/index.vue